import { render, staticRenderFns } from "./LoveMessageForm.vue?vue&type=template&id=52656f40"
import script from "./LoveMessageForm.vue?vue&type=script&lang=js"
export * from "./LoveMessageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports